var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 73,
    viewBox: "0 0 1320 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1320 59.6393C1100 77.4536 880 77.4536 660 59.6393C440 40.6631 220 40.6631 0 59.6393V-2.42889e-06H1320",
    fill: "#E2ECF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWave);
export default __webpack_public_path__ + "static/media/modalWave.e527f4f5a65c23d2bb33f184170d29e0.svg";
export { ForwardRef as ReactComponent };